module.exports = __webpack_public_path__ + "img/logo.919bf445.svg";